import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOfficeShredder1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "office-shredder-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.25,9.748V1.787A1.039,1.039,0,0,1,6.288.748h6.551a1.035,1.035,0,0,1,.734.3l4.873,4.872a1.038,1.038,0,0,1,.3.734V9.748"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.75,6.748H13.788A1.038,1.038,0,0,1,12.75,5.71V.748"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.75,17.248H2.25a1.5,1.5,0,0,1-1.5-1.5v-4.5a1.5,1.5,0,0,1,1.5-1.5h19.5a1.5,1.5,0,0,1,1.5,1.5v4.5a1.5,1.5,0,0,1-1.5,1.5h-3"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 14.248,
			x2: 17.25,
			y2: 14.248
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.75,
			y1: 14.248,
			x2: 9.75,
			y2: 23.248
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.75,
			y1: 14.248,
			x2: 12.75,
			y2: 23.248
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.75,14.248v6a1.5,1.5,0,0,1-1.5,1.5H4.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,14.248v6a1.5,1.5,0,0,0,1.5,1.5H18"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.625,13.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		})
	]
});
export default SvgOfficeShredder1;
